<template>
  <div id="app">
    <div class="container" id="container">
		<nav-home v-if="loginInfo.id>0"></nav-home>
		<div class="ys-container" :class="{'top-0':loginInfo.id == 0}">
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</div>
		<file-preview></file-preview>
	</div>
  </div>
</template>
<script>
import socket from './socket/socket.js'
import NavHome from './views/nav/NavHome.vue'
import FilePreview from './components/FilePreview.vue'
import {getLoginInfo} from './functions/Common.js'
import {mapState} from 'vuex'
	
export default {
	name:"APP",
	components:{
		FilePreview,
		NavHome
	},
	created() {
		  // 登录状态赋值
		  let loginInfo = getLoginInfo()
		  let id = 0
		  let name = ''
		  if(loginInfo){
		  	id = loginInfo.id
			name = loginInfo.name
		  }
		  this.$store.commit('saveLoginInfo',{
			  id:id,
			  name:name
		  })
	},
	mounted() {
		socket(this)
		// 初始化全局的layer
		layui.use(['layer'],function(){
			window.CHAT_LAYER = layui.layer
		})
	},
	
	computed:{
		...mapState(['loginInfo'])
	}
}
</script>
<style>
*{
	border: none;
	padding: 0;
	margin: 0;
	border-style: none;
}
.top-0{
	top: 0 !important;
}
div::-webkit-scrollbar{
	width: 6px;
	height: auto;
}
div::-webkit-scrollbar-track{
  border-radius: 3px;
  background:#e3e3e3;
}
div::-webkit-scrollbar-thumb{
	border-radius: 3px;
	-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
	background:#cbcbcb;
	cursor: pointer;
}
ul::-webkit-scrollbar{
	width: 6px;
	height: auto;
}
ul::-webkit-scrollbar-track{
  border-radius: 3px;
  background:#e3e3e3;
}
ul::-webkit-scrollbar-thumb{
	border-radius: 3px;
	-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
	background:#cbcbcb;
	cursor: pointer;
}
#app {
  font-family:  "microsoft sans serif";
  text-align: left;
  color: #2c3e50;
  font-size: 14px;
}
.container{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ffffff;
}
.container .ys-container{
	position: absolute;
	top: 80px;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
	background-color: #FFFFFF;
}
</style>
